export function PlatanusLogo() {
  return (
    <div className="mt-16 flex justify-center">
      <div
        className="aspect-[576/112] h-7 w-auto sm:h-9 md:h-10"
        style={{
          backgroundColor: 'hsl(var(--primary))',
          maskImage: 'url(/assets/logos/platanus.svg)',
          maskSize: 'contain',
          maskRepeat: 'no-repeat',
          maskPosition: 'center',
          WebkitMaskImage: 'url(/assets/logos/platanus.svg)',
          WebkitMaskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
        }}
      />
    </div>
  );
}
